/* Global imports. */
import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { getCategorySlug } from "@src/kontent";

const LatestArticles = () => {
  const data = useStaticQuery(graphql`
    query LatestArticlesQuery {
      allKontentItemArticle(limit: 3, sort: {elements: {display_date: {value: DESC}}},filter: {elements: {article_categories: {value: {elemMatch: {name: {ne: ""}}}}}}) {
        edges {
          node {
            id
            elements {
              title {
                value
              }
              url_slug {
                value
              }
              display_date {
                value
              }
              article_categories {
                value {
                  name
                  codename
                }
              }
            }
          }
        }
      }
    }
  `)

  const latestArticles = data.allKontentItemArticle.edges

  if(latestArticles && latestArticles.length > 0) {
    return <div id="latest-articles"><ul className="megamenu--latest-articles">
    {latestArticles.map((item, i) => {
      const category = item.node.elements.article_categories.value[0] && item.node.elements.article_categories.value[0].codename && getCategorySlug(item.node.elements.article_categories.value[0].codename)
      var fullSlug = ``

      if(category === 'news') {
        fullSlug = `/news/${item.node.elements.url_slug.value}`
      } else {
        fullSlug = `/blogs/${category}/${item.node.elements.url_slug.value}`
      }
      return  <li key={i}><Link className="text-white no-underline md:text-black hover:text-link" to={fullSlug}>{item.node.elements.title && item.node.elements.title.value}</Link></li>
    })}
    </ul>
    </div>
  } else {
      return <div className="text-white md:text-black">Latest articles unavailable</div>
  }
};

export default LatestArticles;


